import {
  ListenAdaptiveTempoAborted,
  NotifyReact,
  ReactToExerciseEventType,
  RemoveListener,
  SetAdaptiveTempoState,
} from 'Phaser/EventBus';

export class AdaptiveTempoController {
  private base: number;
  private delta: number = 0;
  private isActive: boolean = false;
  private startTimestamp: number = 0;
  private endTimestamp: number = 0;
  private goalTempo: number;
  private isFreePlay: boolean;
  private lowerLimitTempo: number;
  private upperLimitTempo: number;

  private onDone: (finalTempo: number) => void;
  private callbackScope: object | undefined;

  constructor(
    base: number,
    onDone: (finalTempo: number) => void,
    callbackScope: object | undefined,
    goalTempo: number,
    isFreePlay: boolean,
    lowerLimitTempo: number,
    upperLimitTempo: number,
  ) {
    console.debug('[ata] AdaptiveTempoController constructor', {
      base,
      goalTempo,
      isFreePlay,
      lowerLimitTempo,
      upperLimitTempo,
    });
    this.base = base;
    this.delta = 0;
    this.onDone = onDone;
    this.callbackScope = callbackScope;
    this.goalTempo = goalTempo;
    this.isFreePlay = isFreePlay;
    this.lowerLimitTempo = lowerLimitTempo;
    this.upperLimitTempo = upperLimitTempo;
    ListenAdaptiveTempoAborted(this.abortAdaptiveSegment.bind(this));
  }

  setGoalTempo(goalTempo: number) {
    console.debug('[ata] setGoalTempo', goalTempo);
    this.goalTempo = goalTempo;
  }

  setIsFreePlay(isFreePlay: boolean) {
    this.isFreePlay = isFreePlay;
  }

  destroy() {
    RemoveListener(
      ReactToExerciseEventType.AdaptiveTempoAborted,
      this.abortAdaptiveSegment.bind(this),
    );
  }

  shouldStartAdaptiveSegment(delta: number, base: number) {
    console.debug('[ata] shouldStartAdaptiveSegment', {
      base,
      delta,
      lowerLimitTempo: this.lowerLimitTempo,
      upperLimitTempo: this.upperLimitTempo,
      goalTempo: this.goalTempo,
    });
    if (delta < 0) return base > this.lowerLimitTempo;
    return base < Math.min(this.upperLimitTempo, this.goalTempo);
  }

  startAdaptiveSegment(
    base: number,
    delta: number,
    startTimestamp: number,
    endTimestamp: number,
    isBottomPhrase: boolean,
  ) {
    console.debug('[ata] startAdaptiveSegment', {
      base,
      delta,
      startTimestamp,
      isBottomPhrase,
      freePlay: this.isFreePlay,
      goalTempo: this.goalTempo,
    });
    if (
      (delta > 0 && !this.isFreePlay && base >= this.goalTempo) ||
      base >= this.upperLimitTempo ||
      (delta < 0 && base <= this.lowerLimitTempo)
    )
      return;
    const targetTempo = base + delta;
    const newTargetTempo = Math.max(
      Math.min(targetTempo, this.upperLimitTempo, this.goalTempo),
      this.lowerLimitTempo,
    );
    const actualDelta = newTargetTempo - base;
    console.debug('[ata] startAdaptiveSegment', {
      base,
      actualDelta,
      startTimestamp,
      endTimestamp,
      isBottomPhrase,
    });
    this.base = base;
    this.delta = actualDelta;
    this.startTimestamp = startTimestamp;
    this.endTimestamp = endTimestamp;
    this.isActive = true;
    NotifyReact(
      SetAdaptiveTempoState({ state: 'started', value: Math.sign(actualDelta), isBottomPhrase }),
    );
  }

  finishAdaptiveSegment() {
    console.debug('[ata] finishAdaptiveSegment', this.base + this.delta);
    this.isActive = false;
    this.base = this.base + this.delta;
    NotifyReact(SetAdaptiveTempoState({ state: 'completed', value: this.base }));
    this.onDone.call(this.callbackScope, this.base);
  }

  abortAdaptiveSegment() {
    NotifyReact(SetAdaptiveTempoState({ state: 'aborted', value: this.base }));
    this.onDone.call(this.callbackScope, this.base);
  }

  onTick(currentTimestamp: number) {
    /*console.debug(
      '[ata] onTick',
      currentTimestamp,
      this.isActive,
      this.startTimestamp,
      this.endTimestamp,
    );*/
    if (!this.isActive) return;
    const progress =
      (currentTimestamp - this.startTimestamp) / (this.endTimestamp - this.startTimestamp);
    const newTempo = this.base + this.delta * progress;
    if (progress >= 1) {
      this.finishAdaptiveSegment();
    }
    NotifyReact(SetAdaptiveTempoState({ state: 'progress', value: newTempo }));
    return newTempo;
    //NotifyReact(UpdateTempo(newTempo));
  }
}
